import {
  ActionOverRecordTypes,
  FieldBuilder,
  FieldDefinition,
  IActionsSchema,
  MenuCategories,
  MenuSubcategories,
  MENU_CATEGORY_KEY,
  MENU_NAME_SUFFIX,
  MENU_SUBCATEGORY_KEY,
  triggerAction,
  ZendraLocalizationServices,
} from '@zendra/shared';
import type { GridOption } from 'angular-slickgrid';

FieldBuilder.setNamespace('Geographic');

export const PLANTATIONS_TO_GENERATE_FIELDS: FieldDefinition[] = [
  FieldBuilder.number('regionId', 'Entity.Plantation.ToGenerate.RegionId').hideByDefault().gridColumnMinWidth(110).build(),
  FieldBuilder.text('regionCode', 'Entity.Plantation.ToGenerate.RegionCode').gridColumnMinWidth(120).build(),
  FieldBuilder.number('zoneId', 'Entity.Plantation.ToGenerate.ZoneId').hideByDefault().gridColumnMinWidth(100).build(),
  FieldBuilder.text('zoneName', 'Entity.Plantation.ToGenerate.ZoneName').gridColumnMinWidth(140).build(),
  FieldBuilder.number('propertyId', 'Entity.Plantation.ToGenerate.PropertyId').hideByDefault().gridColumnMinWidth(110).build(),
  FieldBuilder.text('propertyName', 'Entity.Plantation.ToGenerate.PropertyName').gridColumnMinWidth(160).build(),
  FieldBuilder.number('standId', 'Entity.Plantation.ToGenerate.StandId').hideByDefault().gridColumnMinWidth(100).build(),
  FieldBuilder.text('standName', 'Entity.Plantation.ToGenerate.StandName').gridColumnMinWidth(140).build(),
  FieldBuilder.date('documentDate', 'Entity.Plantation.ToGenerate.DocumentDate').gridColumnMinWidth(140).build(),
  FieldBuilder.date('stockDate', 'Entity.Plantation.ToGenerate.StockDate').gridColumnMinWidth(140).build(),
  FieldBuilder.number('spacingId', 'Entity.Plantation.ToGenerate.SpacingId').hideByDefault().gridColumnMinWidth(110).build(),
  FieldBuilder.text('spacingName', 'Entity.Plantation.ToGenerate.SpacingName').gridColumnMinWidth(130).build(),
  FieldBuilder.number('standCycle', 'Entity.Plantation.ToGenerate.StandCycle').gridColumnMinWidth(110).build(),
  FieldBuilder.number('standRotation', 'Entity.Plantation.ToGenerate.StandRotation').gridColumnMinWidth(130).build(),
  FieldBuilder.number('standArea', 'Entity.Plantation.ToGenerate.StandArea').decimal().gridColumnMinWidth(120).build(),
  FieldBuilder.number('locationId', 'Entity.Plantation.ToGenerate.LocationId').hideByDefault().gridColumnMinWidth(110).build(),
  FieldBuilder.number('activitySubgroupId', 'Entity.Plantation.ToGenerate.ActivitySubgroupId').hideByDefault().gridColumnMinWidth(170).build(),
  FieldBuilder.number('vendorId', 'Entity.Plantation.ToGenerate.VendorId').hideByDefault().gridColumnMinWidth(100).build(),
  FieldBuilder.text('vendorName', 'Entity.Plantation.ToGenerate.VendorName').gridColumnMinWidth(150).build(),
  FieldBuilder.number('speciesId', 'Entity.Plantation.ToGenerate.SpeciesId').hideByDefault().gridColumnMinWidth(110).build(),
  FieldBuilder.number('geneticMaterialId', 'Entity.Plantation.ToGenerate.GeneticMaterialId').hideByDefault().gridColumnMinWidth(160).build(),
  FieldBuilder.text('geneticMaterialName', 'Entity.Plantation.ToGenerate.GeneticMaterialName').gridColumnMinWidth(180).build(),
  FieldBuilder.number('activityId', 'Entity.Plantation.ToGenerate.ActivityId').hideByDefault().gridColumnMinWidth(110).build(),
];

export const PLANTATIONS_TO_GENERATE_TABLE_OPTIONS: GridOption = {
  enableFiltering: true,
  enableSorting: true,
};

export const PLANTATIONS_TO_GENERATE_ACTION_IDS = {
  generatePlantationsTrigger: 0,
};

export const PLANTATIONS_TO_GENERATE_ACTIONS_CONFIG: IActionsSchema = {
  multipleRecord: [
    triggerAction(
      PLANTATIONS_TO_GENERATE_ACTION_IDS.generatePlantationsTrigger,
      'Action.Trigger.GeneratePlantationsToGenerate',
      ActionOverRecordTypes.MultipleRecord,
      ZendraLocalizationServices.Geographic,
    ),
  ],
};

export const PLANTATIONS_TO_GENERATE_CONFIG = {
  entityName: 'PlantationsToGenerate',
  localizationKey: 'Geographic::Entity.Plantation.ToGenerate',
  fields: PLANTATIONS_TO_GENERATE_FIELDS,
  permission: 'PlanningGeography.Plantations',
  actions: PLANTATIONS_TO_GENERATE_ACTIONS_CONFIG,
  actionIds: PLANTATIONS_TO_GENERATE_ACTION_IDS,
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.TransactionsPlanning + MENU_NAME_SUFFIX,
};
